import { twdClass } from "../../../constants/tailwind.constants";
import { INPUT_TEXT, BTN_CLS } from "../../../constants/var.constants";
import { getSheetInfo, getSheetColumns } from "../../../api/services";
import { processParamValues } from "../../../utils/common.utils";
import PagesGoogleParams from "../pages/PagesGoogleParams";
import { cloneDeep, find, merge } from "lodash";
import { toast } from "react-toastify";
import {Button} from "../../ui/com_ui";
import JSON_PageDesigns from "../../../jsons_pageDesigns";

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";


const PageVariables = ({ loc='popup', updateParamsValues }) => {
 
  const [paramsList, setParamsList] = useState([]);

  const {
    pageInfo
  } = useSelector((state) => state.studioDetails);
  
  const {settings={}} = pageInfo
  const {sheetColumns=[], paramsValues=[]} = settings

  let cols=4, holderS={height:'300px'}

  if(loc=='sidebar'){
    cols=2
    holderS={}
  }

  //console.log("pageInfo", pageInfo)

  useEffect(() => {
    const pageString = JSON.stringify(pageInfo);
    let data = processParamValues(pageString);
    data = data.map((itm) => {
      const val = paramsValues.filter((rc) => rc.replaceTo === itm.key);
      if (val.length > 0) {
        itm.columnValue = val[0].columnValue;
      }
      return itm;
    });
    setParamsList(data);
  }, [pageInfo]);

  
  return (
    <div  className={twdClass("px-2 py-2")} style={holderS}>    
      <div className={twdClass('text-base bg-blue-100 p-2 rounded-lg -mx-2 mb-2')}>
        <div className={twdClass('font-semibold  mb-2')}>How to Use Variables:</div>
        <div className={twdClass('opacity-75 mb-2 text-sm ml-2')}>
          <span className={twdClass('font-semibold')}>Step 1. </span> Type  <span className={twdClass('font-semibold bg-green-100 border border-green-500 px-2 rounded-md')}>&#123;&#123;variable_name&#125;&#125;</span> in your page content where you want the dynamic data to appear.
        </div>
        <div className={twdClass('opacity-75 mb-2  text-sm ml-2')}>
          <span className={twdClass('font-semibold')}>Step 2. </span> Map the <span className={twdClass('font-semibold bg-green-100 border border-green-500  px-2 rounded-md')}>variable_name</span> to the corresponding field in your external data source.
        </div>
      </div>
      <div className={twdClass("flex-1 mr-2 grid grid-cols-2 gap-2")}>       
        {paramsList.map((item) => (
          <PagesGoogleParams
            item={item}
            sheetColumns={sheetColumns}
            updateParamsValues={updateParamsValues}
          />
        ))}  
      </div>    
    </div>
  );
};

export default PageVariables;